import { FormItemProps } from "antd";
import { useMemo } from "react";
import { useIntl } from "react-intl";

import { internalizedDays } from "./consts";

export const useWeekDays = (): FormItemProps[] => {
  const intl = useIntl();

  return useMemo(
    () => [
      {
        label: intl.formatMessage(internalizedDays.Sunday),
        name: "isOnSunday",
      },
      {
        label: intl.formatMessage(internalizedDays.Monday),
        name: "isOnMonday",
      },
      {
        label: intl.formatMessage(internalizedDays.Tuesday),
        name: "isOnTuesday",
      },
      {
        label: intl.formatMessage(internalizedDays.Wednesday),
        name: "isOnWednesday",
      },
      {
        label: intl.formatMessage(internalizedDays.Thursday),
        name: "isOnThursday",
      },
      {
        label: intl.formatMessage(internalizedDays.Friday),
        name: "isOnFriday",
      },
      {
        label: intl.formatMessage(internalizedDays.Saturday),
        name: "isOnSaturday",
      },
    ],
    [intl]
  );
};

export const useWeekdaysValidator = (
  weekdays: boolean[]
): (() => Promise<void>) => {
  const intl = useIntl();

  return async () => {
    if (!weekdays.some((weekdayChecked) => weekdayChecked)) {
      throw new Error(
        intl.formatMessage({
          defaultMessage: "You have to select at least one day.",
        })
      );
    }
  };
};
